import type { AppStore } from "@src/stores/AppStore";
import { gt, required } from "@src/utils/forms/validators";
import { NumberModel } from "@src/utils/models";
import { FieldState, FormState } from "formstate";

export class Form {
  currency_id: FieldState<string>;
  exchange_rate: FieldState<NumberModel>;
  valid_from: FieldState<Date | undefined>;
  valid_to: FieldState<Date | undefined>;
  _form: FormState<FieldState<any>[]>;

  constructor(appStore: AppStore, currencyId?: string) {
    this.reset = this.reset.bind(this);

    this.currency_id = new FieldState(currencyId ?? "").validators(required);
    this.exchange_rate = new FieldState(
      new NumberModel(
        0,
        appStore.workspaceStore.settings?.exchange_rate_denomination!,
      ),
    ).validators(required, gt(0));
    this.valid_from = new FieldState<Date | undefined>(undefined);
    this.valid_to = new FieldState<Date | undefined>(undefined);
    this._form = new FormState([
      this.currency_id,
      this.exchange_rate,
      this.valid_from,
      this.valid_to,
    ]);
  }

  validate(mode: "create" | "update") {
    const fields: FieldState<any>[] = [this.exchange_rate];

    if (mode === "create") {
      fields.push(this.currency_id);
    }

    return new FormState(fields).validate();
  }

  serialize() {
    return {
      exchange_rate: this.exchange_rate.$?.denominatedValue,
      valid_from: this.valid_from.$ ? this.valid_from.$ : null,
      valid_to: this.valid_to.$ ? this.valid_to.$ : null,
      currency_id: this.currency_id.$,
    };
  }

  reset() {
    this._form.reset();
  }
}
